<app-modal-basic #creditInvoiceModal [dialogClass]="'modal-lg'">
  <div class="app-modal-header">
    <h4 class="modal-title">
      {{'admin.backoffice.invoice.credit-invoice.modal-title'| translate }}
    </h4>
    <button type="button" class="close basic-close" (click)="creditInvoiceModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p [innerHTML]="'admin.backoffice.invoice.credit-invoice.are-you-sure'|translate:{invoicenumber: invoiceNumber}"></p>
    {{'admin.backoffice.invoice.credit-invoice-row'|translate }}
    <hr>
    <form novalidate #addCreditInvoiceForm="ngForm">
      <ng-container *ngFor="let creditInvoiceItem of creditInvoiceItems; let i = index">
        <div class="form-row row">
          <div class="form-group col-md-6">
            <label [for]="'description' + i">{{"doctrine.backoffice.credit-invoice.description" | translate}}<span
              class="star">*</span></label>
            <input required [name]="'description' + i"
                   [id]="'description' + i"
                   class="form-control"
                   [(ngModel)]="creditInvoiceItem.description">
            <span class="form-bar"></span>
          </div>
          <div class="form-group col-md-2">
            <label [for]="'amount' + i">{{"doctrine.backoffice.credit-invoice.amount" | translate}}   <span
              class="star">*</span></label>
            <input type="number" required [name]="'amount' + i"
                   [id]="'amount' + i"
                   class="form-control"
                   step="1"
                   [(ngModel)]="creditInvoiceItem.amount">
            <span class="form-bar"></span>
          </div>
          <div class="form-group col-md-2">
            <label [for]="'price' + i">{{"doctrine.backoffice.credit-invoice.price" | translate}} <span
              class="star">*</span></label>
            <input required [name]="'price' + i"
                   type="number"
                   step="0.01"
                   min="-99999"
                   max="99999"
                   [id]="'price' + i"
                   class="form-control"
                   [(ngModel)]="creditInvoiceItem.price">
            <span class="form-bar"></span>
          </div>
          <div class="form-group col-md-2 mt-4" *ngIf="i !== 0">
            <a class="btn btn-lg btn-primary btn-icon ripple light ms-1" (click)="removeCreditItem(i)">
              <i class="fa fa-remove"></i>
            </a>
          </div>
        </div>
      </ng-container>
      <button class="btn btn-primary ripple light" (click)="addCreditItem()">
        <i class="fa fa-plus"></i>
        {{'global.add' | translate}}
      </button>
    </form>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="hideModal()">{{'global.cancel'|translate}}</button>
    <button type="submit" class="btn btn-primary ripple light" (click)="credit()" [disabled]="!addCreditInvoiceForm.valid">
      {{'admin.backoffice.invoice.credit-invoice.modal-credit' | translate}}
    </button>
  </div>
</app-modal-basic>
